import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import {
  TriggerButton,
  Popover as DropdownPopover,
  Option,
  OptionCheck,
} from 'theme/components/SelectionDropdown.style';

export { Option, OptionCheck };

export const FilterWrapper = styled.div`
  position: relative;
  width: 240px;
  flex-shrink: 0;

  @media (max-width: ${breakpoints.tablet}) {
    width: auto;
    flex-shrink: 1;
    min-width: 0;
  }

  ${TriggerButton} > span:first-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }
`;

export const DateRangeButton = styled(TriggerButton)`
  width: 100%;
`;

export const DateRangePopover = styled(DropdownPopover).attrs({
  $openUp: false,
  $fullWidth: true,
})`
  max-height: none;
  overflow: visible;
  min-width: 280px;
`;

export const PresetList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  box-sizing: border-box;
  width: 100%;
`;

export const DateFieldList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 10px 10px;
  box-sizing: border-box;
  width: 100%;
`;

export const DateFieldRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  border-radius: 25px;
  box-sizing: border-box;
  border: 2px solid ${colours.neutral[100]};
  background: white;

  .MuiOutlinedInput-root {
    border-radius: 0;
    background: transparent;
    height: 18px;

    fieldset {
      border: none;
    }
  }

  .MuiOutlinedInput-input {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: ${colours.neutral[900]};
    padding: 0;
  }

  .MuiInputAdornment-root {
    display: none;
  }
`;

export const DateFieldIcon = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${colours.neutral[900]};
`;

export const DateFieldContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

export const calendarPopperSx = {
  '& .MuiPaper-root': {
    fontFamily: "'Inter', sans-serif",
    borderRadius: '25px',
    border: '2px solid rgba(0, 0, 0, 0.05)',
    boxShadow: '0 50px 70px -35px rgba(0, 0, 0, 0.15)',
  },
  '& .MuiPickersCalendarHeader-root': {
    paddingLeft: '20px',
    paddingRight: '12px',
  },
  '& .MuiPickersCalendarHeader-label': {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 600,
    fontSize: '16px',
    color: colours.neutral[900],
    cursor: 'default',
  },
  '& .MuiPickersArrowSwitcher-button': {
    color: colours.neutral[900],
  },
  '& .MuiDateCalendar-root': {
    height: 336,
  },
  '& .MuiDayCalendar-weekDayLabel': {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 500,
    fontSize: '13px',
    color: colours.neutral[500],
  },
  '& .MuiPickersDay-root': {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 500,
    fontSize: '14px',
    color: colours.neutral[900],
    borderRadius: '12px',
    '&:hover': {
      backgroundColor: colours.neutral[100],
    },
    '&.Mui-selected': {
      backgroundColor: colours.neutral[900],
      color: 'white',
      '&:hover': {
        backgroundColor: colours.neutral[800],
      },
      '&:focus': {
        backgroundColor: colours.neutral[900],
      },
    },
    '&.MuiPickersDay-today': {
      border: `2px solid ${colours.neutral[300]}`,
      backgroundColor: 'transparent',
      '&.Mui-selected': {
        border: 'none',
        backgroundColor: colours.neutral[900],
        color: 'white',
      },
    },
  },
  '& .MuiPickersYear-yearButton': {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 500,
    fontSize: '14px',
    color: colours.neutral[900],
    borderRadius: '12px',
    '&:hover': {
      backgroundColor: colours.neutral[100],
    },
    '&.Mui-selected': {
      backgroundColor: colours.neutral[900],
      color: 'white',
      '&:hover': {
        backgroundColor: colours.neutral[800],
      },
    },
  },
};
